import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import NavHeader from '../components/layout/NavHeader/NavHeader';
import Footer from '../components/layout/Footer/Footer';
import AppRoutes from '../routes/AppRoutes';
import { ToastContainer } from 'react-toastify';
import FloatingContactButton from '../components/common/Contact/FloatingContactButton';

function App() {
  return (
    <BrowserRouter>
      <div className="app-wrapper">
        <ToastContainer position="bottom-right" autoClose={3000} />
        <NavHeader />

        <main className="main-content">
          <AppRoutes />
        </main>

        <Footer />
        <FloatingContactButton />
      </div>
    </BrowserRouter>
  );
}

export default App;